import { createContext } from 'react'
import type { Capability } from './permissions'
import type { AuthErrorCode, ChangePasswordInput, Session, SignInInput } from './types'

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous'

export interface AuthContextValue {
  status: AuthStatus
  session: Session | null
  /** Milliseconds left before auto sign-out. Non-null only when close to expiry. */
  idleWarningMs: number | null
  signIn(input: SignInInput): Promise<void>
  signOut(reason?: 'user' | 'idle' | 'expired'): Promise<void>
  changePassword(input: ChangePasswordInput): Promise<void>
  keepAlive(): void
  can(capability: Capability): boolean
  /** Reason for the most recent sign-out, surfaced on the sign-in screen. */
  lastSignOutReason: 'idle' | 'expired' | null
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export const AUTH_ERROR_MESSAGE: Record<AuthErrorCode, string> = {
  invalid_credentials: 'Incorrect email or password.',
  account_locked: 'Account locked. Contact your administrator.',
  too_many_attempts: 'Too many attempts. Try again in 5 minutes.',
  network: 'Cannot reach the server.',
  weak_password: 'Password does not meet the requirements.',
  same_password: 'New password must differ from the current one.',
  session_expired: 'Session expired.',
  unknown: 'Something went wrong.',
}
